function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2847",
  "data-name": "Grupo 2847",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_938",
  "data-name": "Elipse 938",
  cx: 10.08,
  cy: 10.08,
  r: 10.08,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Elipse_938_-_Contorno",
  "data-name": "Elipse 938 - Contorno",
  d: "M10.08,2a8.08,8.08,0,1,0,8.08,8.08A8.089,8.089,0,0,0,10.08,2m0-2A10.08,10.08,0,1,1,0,10.08,10.08,10.08,0,0,1,10.08,0Z",
  fill: "#3f80f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "L\\xEDnea_485",
  "data-name": "L\\xEDnea 485",
  d: "M5.341,6.755-.707.707.707-.707,6.755,5.341Z",
  transform: "translate(15.624 16.632)",
  fill: "#3f80f1"
}));

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.38,
    height: 23.388,
    viewBox: "0 0 22.38 23.388",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.355a98a3.svg";
export { ForwardRef as ReactComponent };